import { useNavigate } from "react-router";
import { RequestProps } from "apis/types/requests";
import { useGetMyRequestQuery } from "apis/services/requests";
import { Spin } from "antd";
import SecondaryPageHeader from "components/general/SecondaryPageHeader";
import SeparatedRowElements from "components/general/SeparatedRowElements";
import Button from "components/general/Button";
import InfoRow from "components/general/InfoRow";
import RequestCard from "components/cards/RequestCard";
import styles from "./styles.module.scss";
import { useGetLeaveBalanceQuery } from "apis/services/other";
import useGetUserInfo from "hooks/useGetUserInfo";
import usePermissions from "hooks/usePermission";

export default function MyRequests() {
  const navigate = useNavigate();
  const { userInfo } = useGetUserInfo();
  const { hasPermissionTo } = usePermissions();
  const viewStatistics = hasPermissionTo("view_balance");
  const applyNewRequest = hasPermissionTo("create_requests");
  const { data, isLoading } = useGetMyRequestQuery({
    page_size: 100,
  });
  const { data: statistics } = useGetLeaveBalanceQuery(
    { cfm_id: userInfo?.id ?? "" },
    { skip: !viewStatistics },
  );
  const INFODATA = [
    {
      title: "All",
      info: statistics?.total || 0,
    },
    {
      title: "Available",
      info: statistics?.balance || 0,
    },
    {
      title: "Used",
      info: statistics?.used || 0,
    },
  ];

  return (
    <div className={styles.container}>
      <SecondaryPageHeader
        title="My Request"
        RightComponent={
          applyNewRequest ? (
            <Button onClick={() => navigate("create-new-request")}>
              Apply New Request
            </Button>
          ) : (
            ""
          )
        }
      />
      {viewStatistics && (
        <SeparatedRowElements>
          {INFODATA.map((item) => (
            <InfoRow
              key={item.title}
              title={`${item.title}:`}
              info={`${item.info} Days`}
              infoFontSize={18}
              infoFontWeight="500"
              containerStyle="py-2"
            />
          ))}
        </SeparatedRowElements>
      )}

      <section className="my-5">
        {isLoading ? (
          <div className="d-flex">
            <Spin className="m-auto" />
          </div>
        ) : (
          data?.results.map((item: RequestProps) => (
            <RequestCard key={item.id} data={item} isMyRequest />
          ))
        )}
      </section>
    </div>
  );
}
